import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

import ClubFeedPopupFooter from './club_feed_popup_footer'
import { clubFeedChannelsMessage, clubFeedPopupTitle } from '../club_feed_channels'

const t = (key) => (window.I18n ? window.I18n.t(key) : '')

export const NOTICE_MODE = 'notice'
export const CONFIRM_MODE = 'confirm'

const ClubFeedNotificationDialog = ({
  mode, action, show, channels, product, settingsUrl, learnMoreUrl, onClose, onSend, onSkip,
}) => {
  const message = clubFeedChannelsMessage(action, channels, product)
  if (!message) {
    return null
  }

  const isConfirm = mode === CONFIRM_MODE
  const titleId = `club_feed_notification_dialog_title_${ mode }`

  return (
    <Modal
      show={ show }
      onHide={ onClose }
      dialogClassName={ isConfirm ? 'club_feed_confirm_popup' : 'club_feed_notice_popup' }
      aria-labelledby={ titleId }
    >
      <div className="modal-body">
        <div className="title" id={ titleId }>
          { clubFeedPopupTitle(action, channels) }
        </div>
        <div id="modal_content">
          <p>{ message }</p>
        </div>
        <ClubFeedPopupFooter
          settingsUrl={ isConfirm ? settingsUrl : null }
          learnMoreUrl={ learnMoreUrl }
          compact={ isConfirm }
        />
        <fieldset className="submit_bar">
          { isConfirm ? (
            <React.Fragment>
              <button type="button"
                      className="btsp_orange_button save_button btn pull-right"
                      disabled={ !show }
                      onClick={ onSend }
              >
                { t('club_feed.confirm_popup.send') }
              </button>
              <button type="button"
                      className="btn button btsp_gray_button pull-right"
                      disabled={ !show }
                      onClick={ onSkip }
              >
                { t('club_feed.confirm_popup.do_not_send') }
              </button>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <a href={ settingsUrl }
                 target="_blank"
                 rel="noopener noreferrer"
                 className="btsp_orange_button btn pull-right"
              >
                { t('club_feed.notice_popup.configure') }
              </a>
              <button type="button" className="btn button btsp_gray_button pull-right" onClick={ onClose }>
                { t('buttons.close_capitalized') }
              </button>
            </React.Fragment>
          ) }
        </fieldset>
      </div>
    </Modal>
  )
}

ClubFeedNotificationDialog.propTypes = {
  mode: PropTypes.oneOf([ NOTICE_MODE, CONFIRM_MODE ]),
  action: PropTypes.string,
  show: PropTypes.bool.isRequired,
  channels: PropTypes.shape({
    feed: PropTypes.bool,
    push: PropTypes.bool,
    push_notification: PropTypes.bool,
  }),
  product: PropTypes.string,
  settingsUrl: PropTypes.string,
  learnMoreUrl: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSend: PropTypes.func,
  onSkip: PropTypes.func,
}

ClubFeedNotificationDialog.defaultProps = {
  mode: NOTICE_MODE,
}

export default ClubFeedNotificationDialog
